

















































import {Component, Prop, Vue} from 'vue-property-decorator';
import InputPageWrapper from '@/views/components/input/InputPageWrapper.vue';

import {UnitSystem} from '@/interfaces/units';
import {ILayerDef} from '@/modules/design/interfaces/shared';
import {calculatePorous} from '@/modules/design/lib/calculations/porousCalculation';
import {findZr} from '@/modules/design/lib/calculations/calculationUtils';
import GenericPavementDiagram from '@/modules/design/views/components/GenericPavementDiagram.vue';
import {createPorousValidations} from '@/modules/design/lib/validations/porous';
import ValidatedInputPageWrapper from '@/views/components/input/ValidatedInputPageWrapper.vue';
import {designStore} from '@/store/store';
import {imperialPrecision, metricPrecision} from "@/main";
import ScenarioInformationReport from "@/modules/design/views/components/report/ScenarioInformationReport.vue";
import DesignParametersReport from "@/modules/design/views/components/report/DesignParametersReport.vue";
import LayersReport from "@/modules/design/views/components/report/LayersReport.vue";


@Component({
  components: {LayersReport,
    DesignParametersReport,
    ScenarioInformationReport, ValidatedInputPageWrapper, GenericPavementDiagram, InputPageWrapper},
})
export default class PorousReport extends Vue {
  @Prop() readonly page!: number;

  get scenario() {
    return designStore.currentPorous;
  }

  get scenarioImperial() {
    return designStore.currentPorousImperial;
    // return store.state.design.currentPorousImperial;
    // store = store.state.design;
  }

  validations() {
    return createPorousValidations(this.scenarioImperial);
  }

  save() {
    designStore.saveCurrentPorousScenario();
  }


  get resultPrecision() {
    return this.scenario.unitSystem === UnitSystem.Imperial ? imperialPrecision : metricPrecision;
  }

  get allInputsOK() {
    const s = this.scenarioImperial;

    console.log(s.layer_0_coefficient);
    console.log(s.loadDiameter_in);
    console.log(s.deltaServiceability);
    console.log(s.reliabilityLevel);
    console.log(s.standardError);
    console.log(s.totalDesignEsals);
    console.log(s.layer_1_modulus_psi);
    console.log(s.layer_2_modulus_psi);
    console.log(s.layer_1_thickness_in);
    return true;
  }

  get resultsImperial() {
    const s = this.scenarioImperial;

    console.log('valid', this.allInputsOK);

    return calculatePorous(
        s.layer_0_coefficient || 0,
        100, // Applied load, PSI -> appears to be default hardcoded in original site
        s.loadDiameter_in || 0,
        s.deltaServiceability || 0,
        findZr(s.reliabilityLevel || 50),
        s.standardError || 0,
        s.totalDesignEsals || 0,
        s.layer_1_modulus_psi || 0,
        s.layer_2_modulus_psi || 0,
        s.layer_1_thickness_in || 0,
    );
  }

  get thicknessUnit() {
    return this.scenario.displayUnits === UnitSystem.Imperial
        ? 'in'
        : 'cm';
  }

  get thicknessMultiplier() {
    return this.scenario.displayUnits === UnitSystem.Imperial
        ? 1
        : 2.54;
  }

  get layers(): ILayerDef[] {
    return [
      {
        name: 'Asphalt - Open Graded',
        type: 'asphalt',
        unit: this.thicknessUnit,
        thickness: Number(this.resultsImperial.asphaltThickness) || 0,
      },
      {
        name: 'Recharge Bed (base)',
        type: 'base',
        unit: this.thicknessUnit,
        thickness: this.scenario.unitSystem === UnitSystem.Imperial
            ? this.scenario.layer_1_thickness_in : this.scenario.layer_1_thickness_cm,
      },
      {
        name: 'Subgrade',
        type: 'subgrade',
        unit: this.thicknessUnit,
        thickness: null,
      },
    ];
  }
}
